export default "./images/survio-J2xe2-assets-team-language.svg";